import { $themeConfig } from '@themeConfig';
import { LANG } from '@/libs/acl/config';
import { setValidationLanguage } from '@core/utils/validations/validations';

export default {
  namespaced: true,
  state: {
    lang: window.localStorage.getItem(LANG) || 'ar',
    layout: {
      isRTL: $themeConfig.layout.isRTL,
      skin: localStorage.getItem('vuexy-skin') || $themeConfig.layout.skin,
      routerTransition: localStorage.getItem('vuexy-transition') || $themeConfig.layout.routerTransition,
      type: localStorage.getItem('vuexy-menu') || $themeConfig.layout.type,
      contentWidth: $themeConfig.layout.contentWidth,
      menu: {
        hidden: localStorage.getItem('vuexy-menuHidden') || $themeConfig.layout.menu.hidden,
      },
      navbar: {
        type: localStorage.getItem('vuexy-navType') || $themeConfig.layout.navbar.type,
        backgroundColor: localStorage.getItem('vuexy-navColor') || $themeConfig.layout.navbar.backgroundColor,
      },
      footer: {
        type: $themeConfig.layout.footer.type,
      },
    },
  },
  getters: {
    lang: (state) => state.lang || 'en',
    isRTL: (state) => state.lang === 'ar',
  },
  mutations: {
    UPDATE_LANG(state, lang) {
      state.lang = lang;
      window.localStorage.setItem(LANG, lang);
    },
    TOGGLE_RTL(state) {
      document.documentElement.setAttribute(
        'dir',
        state.lang === 'ar' ? 'rtl' : 'ltr'
      );
    },
    UPDATE_SKIN(state, skin) {
      state.layout.skin = skin;

      // Update value in localStorage
      localStorage.setItem('vuexy-skin', skin);

      // Update DOM for dark-layout
      if (skin === 'dark') document.body.classList.add('dark-layout');
      else if (document.body.className.match('dark-layout')) {
        document.body.classList.remove('dark-layout');
      }
    },
    UPDATE_ROUTER_TRANSITION(state, val) {
      state.layout.routerTransition = val;
      localStorage.setItem('vuexy-transition', val);
    },
    UPDATE_LAYOUT_TYPE(state, val) {
      state.layout.type = val;
      localStorage.setItem('vuexy-menu', val);
    },
    UPDATE_CONTENT_WIDTH(state, val) {
      state.layout.contentWidth = val;
    },
    UPDATE_NAV_MENU_HIDDEN(state, val) {
      state.layout.menu.hidden = val;
      if (val === true) {
        localStorage.setItem('vuexy-menuHidden', val);
      } else {
        localStorage.setItem('vuexy-menuHidden', '');
      }
    },
    UPDATE_NAVBAR_CONFIG(state, obj) {
      Object.assign(state.layout.navbar, obj);
      if (Object.assign(state.layout.navbar, obj).backgroundColor === '') {
        localStorage.setItem('vuexy-navColor', '');
      }
      if (obj.backgroundColor) {
        localStorage.setItem('vuexy-navColor', Object.assign(state.layout.navbar, obj).backgroundColor);
      }
      if (obj.type) {
        localStorage.setItem('vuexy-navType', obj.type);
      }
    },
    UPDATE_FOOTER_CONFIG(state, obj) {
      Object.assign(state.layout.footer, obj);
    },
  },
  actions: {
    changeLang({ commit }, lang) {
      commit('UPDATE_LANG', lang);
      commit('TOGGLE_RTL');
      setValidationLanguage(lang);
    },
  },
};
